import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/screen-share-off.vue
var o = {
	name: "DtIconScreenShareOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--screen-share-off"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Screen Share Off",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M.94 1.44A1.5 1.5 0 0 1 2 1h4.5a.5.5 0 0 1 0 1H2a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 2 8h8a.5.5 0 0 0 .5-.5V6a.5.5 0 0 1 1 0v1.5A1.5 1.5 0 0 1 10 9H6.5v1H8a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1.5V9H2A1.5 1.5 0 0 1 .5 7.5v-5c0-.398.158-.78.44-1.06Zm7.206-.294a.5.5 0 0 1 .708 0l.896.897.896-.897a.5.5 0 0 1 .708.708l-.897.896.897.896a.5.5 0 0 1-.708.708l-.896-.897-.896.897a.5.5 0 1 1-.708-.708l.897-.896-.897-.896a.5.5 0 0 1 0-.708Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=screen-share-off.js.map